module.exports = __webpack_public_path__ + "static/media/geometryImage2.a1b67742.svg";